<!--
 * @Description: 工单完成率
 * @Autor: xiaona.wang
 * @Date: 2021-12-14 20:56:34
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-07-18 16:45:57
-->
<template>
  <div class="order-complete-warp">
    <div class="tab_wrap">
      <span class="tab_button" :class="{ bgColor: timeFilterType === 'NEARLY' }" @click="buttonClick('NEARLY')">近30天</span>
      <span class="tab_button" :class="{ bgColor: timeFilterType === 'CURRENT_MONTH' }" @click="buttonClick('CURRENT_MONTH')">本月</span>
    </div>
    <div id="order_complete_rate" class="box_conetnt" />
  </div>
</template>

<script>
import * as echarts from "echarts";
import cockpitApi from "@/api/cockpit/cockpit";
import resize from "./mixins/resize";

export default {
  name: "OrderCompleteRate",
  mixins: [resize],
  data() {
    return {
      chart: null,
      timeFilterType: "NEARLY"
    };
  },
  watch: {
  },
  mounted() {
    this.$nextTick(() => {
      this.getOrderCompleteRate();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeSetData() {
      setTimeout(() => {
        this.chart && this.chart.resize();
      }, 200);
    },
    buttonClick(type) {
      this.timeFilterType = type;
      this.getOrderCompleteRate(type);
    },
    // 工单完成率
    getOrderCompleteRate(type = "NEARLY") {
      cockpitApi.getOrderCompleteRate({ searchType: type }).then(result => {
        if (result.code === 200 && result.success) {
          const { dateList, maintainRateData, faultRateData: repairRateData, spotCheckRateData } = result.data;
          this.drawInformationTrends(dateList, maintainRateData, repairRateData, spotCheckRateData);
        }
      });
    },
    // echarts 工单完成率
    drawInformationTrends(dateList = [], maintainRateData = [], repairRateData = [], spotCheckRateData = []) {
      this.chart = echarts.init(document.getElementById("order_complete_rate"));
      const dateListNew = [];
      if (dateList && dateList.length > 0) {
        for (let i = 0; i < dateList.length; i++) {
          const dateNew = `${this.dayjs(dateList[i]).format("MM-DD")}`;
          dateListNew.push(dateNew);
        }
      }
      // 格式化日期
      this.chart.setOption({
        color: ["#FBC439", "#6E90FF", "#49C3BA"],
        title: {
          text: "工单完成率"
          // left: 16,
          // top: 16,
        },
        grid: {
          top: "50px",
          left: "1%",
          right: "2%",
          bottom: "30px",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter(data) {
            const year = new Date().getFullYear();
            let res = `${year}-${data[0].name}<br/>`;
            for (let i = 0, len = data.length; i < len; i++) {
              res += `${data[i].marker}&nbsp;`;
              res += `${data[i].seriesName}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
              res += `${data[i].value}%<br/>`;
            }
            return res;
          }
        },
        legend: {
          icon: "circle",
          bottom: "0",
          itemHeight: 8,
          itemWidth: 8
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: dateListNew,
          axisLine: {
            show: true,
            lineStyle: {
              type: "solid", // x轴线条类型
              color: "#EEE", // x轴线条颜色
              width: "1" // x轴线条宽度
            }
          },
          axisLabel: {
            textStyle: {
              color: "#595959" // x轴文本颜色
            }
          }
        },
        yAxis: [
          {
            type: "value",
            name: "%",
            nameTextStyle: {
              color: "#21252E",
              verticalAlign: "middle",
              padding: [0, 0, 0, -20]
            },
            axisLine: {
              show: true,
              lineStyle: {
                type: "solid",
                color: "#EEE",
                width: "1"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#595959" // y轴文本颜色
              }
            }
          }
        ],
        series: [
          { name: "维修", type: "line", data: repairRateData },
          { name: "保养", type: "line", data: maintainRateData },
          { name: "点检", type: "line", data: spotCheckRateData }
          // { name: "维修", type: "line", data: [10, 40, 50, 5, 45, 45, 43, 53, 5, 43, 43, 43, 5, 42, 54] },
          // { name: "保养", type: "line", data: [10, 40, 50, 50, 50, 10, 40, 50, 50, 50, 10, 40, 50, 50, 50, 10, 40, 50, 50, 50] },
          // { name: "点检", type: "line", data: [45, 43, 5, 43, 54, 5, 43, 5, 43, 54, 3, 54, 5, 43, 5, 43, 5, 43, 53, 5, 43, 5, 43, 5, 43, 5, 43, 5, 43, 35] },
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.order-complete-warp{
  width:100%;
  height:100%;
  padding:24px 24px 16px;
}
#order_complete_rate{
  width:100%;
  height:100%;
}
.tab_wrap {
  position: absolute;
  text-align: center;
  color: #5b5b5c;
  right: 36px;
  top: 16px;
  z-index: 99;
  .tab_button {
    display: inline-block;
    width: 80px;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
    color: #505363;
  }
  .bgColor {
    background-color: #00b259;
    color: #fff;
  }
}
</style>
